// AI-assisted executive summary card + the report metadata panel beside it.
// In Phase 1 `summaryText` is a deterministic fallback derived from the CDI
// percentages; Phase 2 swaps in the streamed LLM narrative via the same prop.

import ChartAwareMarkdown from "../../ChartAwareMarkdown";

function SummarySkeleton() {
  return (
    <div className="exec-summary__skeleton">
      <span style={{ width: "92%" }} />
      <span style={{ width: "78%" }} />
      <span style={{ width: "85%" }} />
    </div>
  );
}

/**
 * @param {object} props
 * @param {string} props.summaryText Markdown narrative (fallback or streamed).
 * @param {boolean} props.streaming Whether the narrative is still arriving.
 * @param {string|null} props.error Narrative error, if any.
 * @param {object} props.meta `{ periodCycle, country, cdiDate, spiDate }`.
 */
export default function ExecutiveSummary({ summaryText, streaming, error, meta }) {
  return (
    <section className="exec-summary">
      <div className="exec-summary__card">
        <p className="exec-summary__title">AI-assisted executive summary</p>
        {error && !summaryText ? (
          <p className="exec-summary__error">{error}</p>
        ) : summaryText ? (
          <div className="exec-summary__body">
            <ChartAwareMarkdown text={summaryText} chartData={{}} />
            {streaming && <span className="streaming-dot" />}
          </div>
        ) : (
          <SummarySkeleton />
        )}
      </div>

      <dl className="exec-summary__meta">
        <div>
          <dt>Period cycle</dt>
          <dd>{meta.periodCycle}</dd>
        </div>
        <div>
          <dt>Country</dt>
          <dd>{meta.country}</dd>
        </div>
        <div>
          <dt>CDI date</dt>
          <dd>{meta.cdiDate}</dd>
        </div>
        <div>
          <dt>SPI date</dt>
          <dd>{meta.spiDate}</dd>
        </div>
      </dl>
    </section>
  );
}
